import http from '../common/http-common';


import { DTOEquipoInventario } from '../../DTO/Inventario/DTOEquipoInventario';

// import { DTOMonitorInventario } from '../../DTO/Inventario/DTOMonitorInventario';
import {
  DTOMonitorInventario,
  FiltroMonitores,
} from "../../DTO/Inventario/DTOMonitorInventario";
 import { DTOIPInventario } from '../../DTO/Inventario/DTOIPInventario';


import {
  DTOEstadoEquipo,
  DTOSegmentoRed,
  DTOTipoEquipo,
} 
from '../../DTO/Inventario/DTOCatalogosInventario'


import {
  DTOGestionarEquipo,
  DTOGestionarIP,
  DTOGestionarMonitor,
  DTOGestionarSegmentoRed,
  DTOResultadoGestion,
} 
from '../../DTO/Inventario/DTOGestionInventario'
import {
  DTODisponibilidadIP,
  DTOResumenDisponibilidadIP,
} from "../../DTO/Inventario/DTODisponibilidadIP";
import {
  DTOBitacoraEvidencia,
  DTOFiltroBitacoraEvidencias,
  DTOGestionarBitacoraEvidencia,
  DTOGestionarOpcionEvidencia,
  DTOInventarioArchivoAdjunto,
  DTOOpcionEvidencia,
  DTOResultadoCargaArchivos,
} from "../../DTO/Inventario/DTOBitacoraEvidencia";



class InventarioService {
  obtenerEquipos() {
    return http.get<DTOEquipoInventario[]>(
      '/inventario/equipos'
    );
  }

  obtenerEquipoPorId(idEquipo: number) {
    return http.get<DTOEquipoInventario>(
      `/inventario/equipos/${idEquipo}`
    );
  }

  obtenerMonitores(filtro: FiltroMonitores = "TODOS") {
  return http.get<DTOMonitorInventario[]>(
    "/inventario/monitores",
    {
      params: {
        filtro,
      },
    }
  );
}



  obtenerMonitoresPorEquipo(idEquipo: number) {
    return http.get<DTOMonitorInventario[]>(
      `/inventario/equipos/${idEquipo}/monitores`
    );
  }


  obtenerResumenDisponibilidadIPs() {
  return http.get<DTOResumenDisponibilidadIP[]>(
    "/inventario/ips/disponibilidad/resumen"
  );
}

obtenerDisponibilidadIPsPorSegmento(
  idSegmento: number,
  soloLibres: boolean | null = null
) {
  return http.get<DTODisponibilidadIP[]>(
    `/inventario/ips/disponibilidad/${idSegmento}`,
    {
      params:
        soloLibres === null
          ? {}
          : {
              soloLibres,
            },
    }
  );
}

  
  obtenerIPsPorEquipo(idEquipo: number) {
    return http.get<DTOIPInventario[]>(
      `/inventario/equipos/${idEquipo}/ips`
    );
  }

  obtenerTiposEquipo() {
    return http.get<DTOTipoEquipo[]>(
      '/inventario/catalogos/tipos-equipo'
    );
  }

  obtenerEstadosEquipo() {
    return http.get<DTOEstadoEquipo[]>(
      '/inventario/catalogos/estados-equipo'
    );
  }

  obtenerSegmentosRed() {
    return http.get<DTOSegmentoRed[]>(
      '/inventario/catalogos/segmentos-red'
    );
  }

  gestionarEquipo(dto: DTOGestionarEquipo) {
    return http.post<DTOResultadoGestion>(
      '/inventario/equipos/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  gestionarMonitor(dto: DTOGestionarMonitor) {
    return http.post<DTOResultadoGestion>(
      '/inventario/monitores/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  gestionarIP(dto: DTOGestionarIP) {
    return http.post<DTOResultadoGestion>(
      '/inventario/ips/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  gestionarSegmentoRed(dto: DTOGestionarSegmentoRed) {
    return http.post<DTOResultadoGestion>(
      '/inventario/segmentos-red/gestionar',
      dto,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  obtenerBitacoraEvidencias(
    filtro: DTOFiltroBitacoraEvidencias = {}
  ) {
    return http.get<DTOBitacoraEvidencia[]>(
      "/inventario/bitacora-evidencias",
      { params: filtro }
    );
  }

  obtenerEvidenciaPorId(idEvidencia: number) {
    return http.get<DTOBitacoraEvidencia>(
      `/inventario/bitacora-evidencias/${idEvidencia}`
    );
  }

  gestionarBitacoraEvidencia(dto: DTOGestionarBitacoraEvidencia) {
    return http.post<DTOResultadoGestion>(
      "/inventario/bitacora-evidencias/gestionar",
      dto,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  obtenerCatalogosEvidencias(incluirInactivos = false) {
    return http.get<DTOOpcionEvidencia[]>(
      "/inventario/catalogos/evidencias",
      { params: { incluirInactivos } }
    );
  }

  gestionarCatalogoEvidencia(dto: DTOGestionarOpcionEvidencia) {
    return http.post<DTOResultadoGestion>(
      "/inventario/catalogos/evidencias/gestionar",
      dto,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
  }

  obtenerArchivosEvidencia(idEvidencia: number, incluirEliminados = true) {
    return http.get<DTOInventarioArchivoAdjunto[]>(
      `/inventario/archivos-adjuntos/EVIDENCIA/${idEvidencia}`,
      { params: { incluirEliminados } }
    );
  }

  subirArchivosEvidencia(
    idEvidencia: number,
    archivos: File[],
    categoriaArchivo: string,
    descripcion?: string | null
  ) {
    const formulario = new FormData();
    archivos.forEach((archivo) => formulario.append("archivos", archivo));
    formulario.append("categoriaArchivo", categoriaArchivo);
    if (descripcion?.trim()) {
      formulario.append("descripcion", descripcion.trim());
    }

    return http.post<DTOResultadoCargaArchivos>(
      `/inventario/archivos-adjuntos/EVIDENCIA/${idEvidencia}`,
      formulario,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  }

  obtenerContenidoArchivo(idArchivoAdjunto: number, inline = true) {
    return http.get<Blob>(
      `/inventario/archivos-adjuntos/${idArchivoAdjunto}/contenido`,
      { params: { inline }, responseType: "blob" }
    );
  }

  eliminarArchivoAdjunto(idArchivoAdjunto: number) {
    return http.delete<DTOResultadoGestion>(
      `/inventario/archivos-adjuntos/${idArchivoAdjunto}`
    );
  }
}

export default new InventarioService();
